// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartDateSelection = createAction('[Fund Chart] Set date selection', props());
